(() => {
  'use strict';
  if (window.msxPurchaseReady) return;
  window.msxPurchaseReady = true;
  let pending = false;
  const rootPath = () => (window.Shopify?.routes?.root || window.routes?.root_url || '/').replace(/\/?$/, '/');
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-msx-purchase-button]');
    if (!button || button.disabled) return;
    event.preventDefault();
    if (pending) return;
    const container = button.closest('[data-msx-product]') || button.closest('.msx-product-card');
    const previousError = container?.querySelector('[data-msx-purchase-error]');
    previousError?.remove();
    if (button.dataset.purchaseMode === 'amazon') {
      // Liquid already restricts destinations to this country's Amazon domain.
      try {
        const url = new URL(button.dataset.amazonUrl);
        if (url.protocol !== 'https:' || !/^((www\.)?amazon\.(com|co\.uk|de|fr|it|es))$/.test(url.hostname)) return;
        if (button.dataset.newtab === 'false') window.location.assign(url.href);
        else window.open(url.href, '_blank', 'noopener,noreferrer');
      } catch (_) { /* Never navigate to an invalid external URL. */ }
      return;
    }
    const input = container?.querySelector('[data-msx-quantity-input]');
    if (input && !input.reportValidity()) return;
    const quantity = Number(input?.value || button.dataset.minimumQuantity || 1);
    const id = Number(button.dataset.variantId);
    if (!Number.isInteger(quantity) || quantity < 1 || !Number.isSafeInteger(id) || id < 1) return;
    pending = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const controls = [...(container?.querySelectorAll('[data-msx-option-input], [data-msx-quantity-input], [data-msx-quantity-minus], [data-msx-quantity-plus]') || [])];
    const disabledStates = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    try {
      const response = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] }),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(typeof payload.description === 'string' ? payload.description : window.cartStrings?.error);
      if (!Array.isArray(payload.items) || !payload.items.some(item => Number(item.id) === id)) throw new Error(window.cartStrings?.error);
      // Keep existing cart contents. No order or payment is submitted here.
      window.location.assign(rootPath() + 'checkout');
    } catch (error) {
      const message = document.createElement('p');
      message.dataset.msxPurchaseError = '';
      message.className = 'msx-copy msx-purchase-error';
      message.setAttribute('role', 'alert');
      message.textContent = error.message || window.cartStrings?.error || 'Unable to continue. Please check your cart before trying again.';
      button.parentElement.insertAdjacentElement('afterend', message);
      pending = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
    }
  });
})();
